import React from 'react';
import Highlighter from 'react-highlight-words';
import { Link } from "react-router-dom";
import {
	Card,
	Input,
	Button,
	Table,
	Modal,
	message,
	Tag,
	Tooltip,
	Typography,
	Pagination,
} from 'antd';
import {
	SearchOutlined,
	PlusOutlined,
	FormOutlined,
	CloseSquareOutlined,
	ExclamationCircleOutlined,
	RedoOutlined,
	SettingOutlined,
	CheckCircleOutlined,
	PrinterOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
} from "../../store/actions";

import Config from '../../Config';
import {Helmet} from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Data Printer',
	apiUrl: {
		data: 'addons/api/printer/',
		userProfile: "auth/api/user/info/"
	},
	pageUrl: {
		form: '/admin/pengaturan/printer/form/'
	},
	breadCrumb: [
		<span><SettingOutlined /> Pengaturan</span>,
		'Printer',
	]

}

const config = new Config();

class DataPengaturanPrinter extends React.Component {
	constructor(props){
		super(props);
		this.state = {
			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			searchColumn: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		}
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount(){
		this.props.initHandler();
	}

	componentDidMount(){
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount(){
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	showDeleteConfirm(id) {
	  Modal.confirm({
	    title: 'Konfirmasi Hapus?',
	    icon: <ExclamationCircleOutlined />,
	    content: 'yakin menghapus data?',
	    okText: 'Ya',
	    okType: 'danger',
	    cancelText: 'Tidak',
	    onOk: () => this.prosesHapus(id),
	    onCancel() {
	      //console.log('Cancel');
	    },
	  });
	}

	showPilihConfirm(id) {
	  Modal.confirm({
	    title: 'Konfirmasi Pilih Printer?',
	    icon: <ExclamationCircleOutlined />,
	    content: 'yakin memilih printer?',
	    okText: 'Ya',
	    okType: 'danger',
	    cancelText: 'Tidak',
	    onOk: () => this.prosesPilih(id),
	    onCancel() {
	      //console.log('Cancel');
	    },
	  });
	}

	prosesHapus(id) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler('delete', configClass.apiUrl.data+id+'/')
		.then(() =>{
			this.setState({
				loadingButton: false
			});
			if(this.props.isSuccess){
				message.success({ content: 'berhasil menghapus data', duration: 2, key: 'toast' });
				this.getData();
			}else{
				const errTitle = 'gagal menghapus data'
				message.error({ content: errTitle, duration: 2, key: 'toast' });
				this.setState({
					errTitle: errTitle,
					errMsg: this.props.responseMsg
				});
			}
		}).catch((response) => {
			console.log('gagal_delete', response);
			this.setState({
				loadingButton: false
			});
			message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
		});
	}

	prosesPilih(id) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler('post', configClass.apiUrl.data+id+'/select/')
		.then(() =>{
			this.setState({
				loadingButton: false
			});
			if(this.props.isSuccess){
				message.success({ content: 'berhasil memilih printer', duration: 2, key: 'toast' });
				this.getProfile();
			}else{
				const errTitle = 'gagal menghapus data'
				message.error({ content: errTitle, duration: 2, key: 'toast' });
				this.setState({
					errTitle: errTitle,
					errMsg: this.props.responseMsg
				});
			}
		}).catch((response) => {
			console.log('gagal_delete', response);
			this.setState({
				loadingButton: false
			});
			message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
		});
	}

	getColumnSearchProps = dataIndex => ({
	    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
	      <div style={{ padding: 8 }}>
	        <Input
	          ref={node => {
	            this.searchInput = node;
	          }}
	          placeholder={`Search ${dataIndex}`}
	          value={selectedKeys[0]}
	          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
	          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
	          style={{ width: 188, marginBottom: 8, display: 'block' }}
	        />
	        <Button
	          type="primary"
	          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
	          icon={<SearchOutlined />}
	          size="small"
	          style={{ width: 90, marginRight: 8 }}
	        >
	          Search
	        </Button>
	        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
	          Reset
	        </Button>
	      </div>
	    ),
	    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
	    onFilter: (value, record) =>
	      record[dataIndex]
	        .toString()
	        .toLowerCase()
	        .includes(value.toLowerCase()),
	    onFilterDropdownVisibleChange: visible => {
	      if (visible) {
	        setTimeout(() => this.searchInput.select());
	      }
	    },
	    render: text =>
	      this.state.searchedColumn == dataIndex ? (
	        <Highlighter
	          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
	          searchWords={[this.state.searchText]}
	          autoEscape
	          textToHighlight={text.toString()}
	        />
	      ) : (
	        text
	      ),
	});

	handleSearch = (selectedKeys, confirm, dataIndex) => {
	    confirm();
	    this.setState({
	      searchText: selectedKeys[0],
	      searchedColumn: dataIndex,
	    });
	};

	handleReset = clearFilters => {
	    clearFilters();
	    this.setState({ searchText: '' });
	};

	async getData(limit=this.state.pagination.pageSize, offset=0, search=this.state.searchText){
		this.setState({loadingData: true});

		this.props.ajaxViewHandler('get', configClass.apiUrl.data+'?limit='+limit+'&offset='+offset+'&search='+search)
		.then(() =>{
			const data = this.props.responseMsg;
			if(this.props.isSuccess){
				this.setState(prev => ({
					dataSource: data.results,
					pagination: { ...prev.pagination, total: data.count },
				}));
	        }else{
	        	const errTitle = 'error get data';
	        	this.setState({
	        		errTitle: errTitle,
	        		errMsg: this.props.responseMsg
	        	});
	        	message.error({ content: errTitle, duration: 2, key: 'toast' });
	        }
	        this.setState({loadingData: false});
		}).catch((response) => {
			console.log('gagal_get_preview', response);
			message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
			this.setState({loadingData: false});
		});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	async getProfile(){
		this.props.ajaxViewHandler('get', configClass.apiUrl.userProfile)
		.then(() =>{
			const data = this.props.responseMsg;
			// console.log('data_profile', data);
			if(data != undefined){
				this.props.setConfig({
		        	username: data.username,
		        	id: data.id,
		        	// pp: this.config.get_site_info().logo,
		        	nama: data.pegawai[0].nama,
		        	akses: data.access,
		        	printer: data.pegawai[0].serial_printer != undefined ? data.pegawai[0].serial_printer : "pengaturan printer belum dipilih",
		        	nama_printer: data.pegawai[0].nama_printer != undefined ? data.pegawai[0].nama_printer : "pengaturan printer belum dipilih",
		        });

		        // askForPermissioToReceiveNotifications(data[0].tempatTugas);

		        // if(!this.props.switchable){
		        // 	// this.props.setConfig({
		        // 	// 	isSuperadmin: data[0].is_superuser
		        // 	// });
		        // }
			}
		}).catch((response) => {
			console.log('gagal_getprofile', response);
			message.error({ content: 'gagal request data profile, coba lagi', key: 'toast' });
		});
	}

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return (
						<Text style={{ fontSize: 12, color: '#888' }}>
							{(pagination.current - 1) * pagination.pageSize + index + 1}
						</Text>
					);
				},
			},
			{
				title: 'Nama',
				dataIndex: 'nama',
				key: 'nama',
				render: (value, row) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{
							width: 34, height: 34, borderRadius: 8,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
						}}>
							<PrinterOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>
							{value || '—'}
							{row.serial === this.props.printer && (
								<Tag style={{ marginLeft: 8, borderRadius: 20, fontWeight: 600, fontSize: 11, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }}>
									Default
								</Tag>
							)}
						</div>
					</div>
				),
			},
			{
				title: 'Tipe',
				dataIndex: 'tipe',
				key: 'tipe',
				width: 130,
				align: 'center',
				render: (value) => (
					<Tag style={{
						borderRadius: 20, fontWeight: 600, fontSize: 12,
						background: value == "1" ? '#fffbe6' : '#f6ffed',
						borderColor: value == "1" ? '#ffe58f' : '#b7eb8f',
						color: value == "1" ? '#ad6800' : '#389e0d',
					}}>
						{value == "1" ? 'Kutipan' : 'Notice'}
					</Tag>
				),
			},
			{
				title: 'Serial',
				dataIndex: 'serial',
				key: 'serial',
				render: (val) => val ? <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{val}</span> : <Text type="secondary">—</Text>,
			},
			{
				title: 'Aksi',
				key: 'aksi',
				width: 130,
				fixed: 'right',
				align: 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Link to={configClass.pageUrl.form + row.id}>
							<Tooltip title="Edit">
								<Button size="small" shape="circle" type="primary" ghost>
									<FormOutlined />
								</Button>
							</Tooltip>
						</Link>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
						<Tooltip title="Pilih sebagai printer default">
							<Button
								size="small"
								shape="circle"
								style={{ background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }}
								onClick={() => this.showPilihConfirm(row.id)}
							>
								<CheckCircleOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<PrinterOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847', lineHeight: 1.3 }}>
							{row.nama}
						</div>
						<div style={{ display: 'flex', gap: 6, marginTop: 5, flexWrap: 'wrap' }}>
							<Tag style={{
								borderRadius: 20, fontSize: 11, margin: 0,
								background: row.tipe == "1" ? '#fffbe6' : '#f6ffed',
								borderColor: row.tipe == "1" ? '#ffe58f' : '#b7eb8f',
								color: row.tipe == "1" ? '#ad6800' : '#389e0d',
								fontWeight: 600,
							}}>
								{row.tipe == "1" ? 'Kutipan' : 'Notice'}
							</Tag>
							{row.serial === this.props.printer && (
								<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a', fontWeight: 600 }}>
									Default
								</Tag>
							)}
						</div>
					</div>
				</div>
				<div style={{ padding: '10px 16px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
						<Text type="secondary" style={{ fontSize: 12 }}>Serial</Text>
						<Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{row.serial || '—'}</Text>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						<Link to={configClass.pageUrl.form + row.id} style={{ flex: 1 }}>
							<Button block size="small" icon={<FormOutlined />}>Edit</Button>
						</Link>
						<Button block size="small" danger icon={<CloseSquareOutlined />} style={{ flex: 1 }} onClick={() => this.showDeleteConfirm(row.id)}>Hapus</Button>
						<Button block size="small" icon={<CheckCircleOutlined />} style={{ flex: 1, background: '#f6ffed', borderColor: '#52c41a', color: '#52c41a' }} onClick={() => this.showPilihConfirm(row.id)}>Pilih</Button>
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;

		return(
			<div>
				<Helmet>
					<title>{configClass.title+" | "+config.get_site_info().name}</title>
					<style>{`
						.data-printer-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-printer-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-printer-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-printer-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-printer-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-printer-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<PrinterOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} printer terdaftar
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => {
										this.setState(
											prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
											() => this.getData(this.state.pagination.pageSize, 0, '')
										);
									}}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Link to={configClass.pageUrl.form}>
								<Button
									type="primary"
									icon={<PlusOutlined />}
									style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
								>
									{isMobile ? 'Tambah' : 'Tambah Printer'}
								</Button>
							</Link>
						</div>
					</div>

					{/* Search bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nama atau serial printer..."
							allowClear
							size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 340 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => {
								this.setState(
									prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
									() => this.getData(this.state.pagination.pageSize, 0, '')
								);
							}}
						/>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = function(state) {
	return state.configReducers
}

export default connect(
		mapStateToProps,
		{
			initHandler,
			setConfig,
			ajaxViewHandler,
			ajaxHandler
		}
	)(DataPengaturanPrinter);